module.exports = __webpack_public_path__ + "img/trains2.c4509964.svg";